import { t } from 'i18next';
import React, { useState } from 'react';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from '../../../components/mplat/Button/Button';
import Form from '../../../components/mplat/Form';
import { TotpModal } from '../../../components/mplat/Home/HomeAuth';
import { EmailValidationModal } from '../../../components/mplat/Modals/EmailValidationModal';
import { ForgotPasswordModal } from '../../../components/mplat/Modals/ForgotPasswordModal';
import { LoginModal, useLogin } from '../../../components/mplat/Modals/LoginModal';

interface AuthFormData {
    email: string;
    password: string;
}

const WelcomeAuth: React.FC = () => {
    const login = useLogin();

    const [showLogin, setShowLogin] = useState(false);
    const [showRegistration, setShowRegistration] = useState(false);
    const [showForgot, setShowForgot] = useState(false);
    const [showTotp, setShowTotp] = useState(false);

    const [error, setError] = useState('');
    const [empty, setEmpty] = useState<boolean>();
    const emptyUsername = t('Enter Email');
    const emptyPassword = t('Enter password');

    const [formData, setFormData] = useState<AuthFormData>({
        email: '',
        password: ''
    });

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { type, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [type]: value
        }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Обработка отправки формы
        console.log('Form submitted:', formData);
    };

    return (
        <div className="welcome-auth">
            {showLogin && <LoginModal isOpen={showLogin} onClose={() => setShowLogin(false)} />}
            {showRegistration && <EmailValidationModal isOpen={showRegistration} onClose={() => setShowRegistration(false)} />}
            {showForgot && <ForgotPasswordModal isOpen={showForgot} onClose={() => setShowForgot(false)} />}
            {showTotp && <TotpModal user={formData.email} password={formData.password} isOpen={showTotp} onClose={() => setShowTotp(false)} onSuccess={() => {setShowTotp(false); }} />}

            <div className="welcome-auth__login">
                <div className="welcome-auth__login-heading" onClick={() => setShowLogin(true)}><Trans>Sign</Trans></div>
                <Form onSubmit={handleSubmit} className="welcome-auth__login-form">
                    <h2 className="popup__heading"><Trans>Sign</Trans></h2>
                    <div className="form__item welcome-auth__login-item _input">
                        <input
                            type="email"
                            name="username"
                            className={`form__input _required${((error || (empty && !formData.email)) ? ' _error' : '')}`}
                            required
                            placeholder={t('Email')}
                            value={formData.email}
                            onChange={handleInputChange}
                        />
                        {(empty && !formData.email) && <div className="form__input-error-message">{emptyUsername}</div>}
                        {error && <div className="form__input-error-message">{error}</div>}
                    </div>
                    <div className="form__item welcome-auth__login-item _input">
                        <input
                            type="password"
                            name="password"
                            className={`form__input _required${((error || (empty && !formData.password)) ? ' _error' : '')}`}
                            required
                            placeholder={t('Password')}
                            value={formData.password}
                            onChange={handleInputChange}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    setError('');
                                    let isEmpty = false;
                                    if (!formData.email) {
                                        isEmpty = true;
                                    }
                                    if (!formData.password) {
                                        isEmpty = true;
                                    }
                                    setEmpty(isEmpty);
                                    if (isEmpty) {
                                        return;
                                    }
                                    login(formData.email, formData.password, undefined, () => setShowTotp(true), undefined, (err) => setError(err));
                                }
                            }}
                        />
                        {(empty && !formData.password) && <div className="form__input-error-message">{emptyPassword}</div>}
                    </div>
                    <div className="form__item welcome-auth__login-item _submit">
                        <Button
                            className="_bd-accent"
                            name="sign_in"
                            onClick={() => {
                                setError('');
                                let isEmpty = false;
                                if (!formData.email) {
                                    isEmpty = true;
                                }
                                if (!formData.password) {
                                    isEmpty = true;
                                }
                                setEmpty(isEmpty);
                                if (isEmpty) {
                                    return;
                                }
                                login(formData.email, formData.password, undefined, () => setShowTotp(true), undefined, (err) => setError(err));
                            }}
                        >
                            <Trans>Sign in</Trans>
                        </Button>
                    </div>
                    <div className="welcome-auth__login-item link link-accent _forgot" onClick={() => setShowForgot(true)}>
                        <Trans>Forgot password</Trans>?
                    </div>
                </Form>
            </div>
            <div className="welcome-auth__reg">
                <Link to="#signup" className="btn" onClick={(e) => { e.preventDefault(); setShowRegistration(true); }}>
                    <Trans>Sign Up</Trans>
                </Link>
            </div>
        </div>
    );
};

export default WelcomeAuth;